import React from 'react';
import { Box, GridItem } from '@chakra-ui/react';

const NatureMorte = () => {
  return (
    <Box>
      <Box as="h1" fontSize="34px" textTransform="uppercase" mb={5}>
        NATURE MORTE
      </Box>
      <GridItem as="p">Identité digitale & site vitrine pour une boutique vintage parisienne</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [Objectifs]
      </Box>
      <GridItem as="p">- Créer une identité digitale pour une boutique vintage parisienne.</GridItem>
      <GridItem as="p">- Concevoir un site vitrine responsive mettant en valeur produits et événements.</GridItem>
      <GridItem as="p">- Proposer une expérience utilisateur immersive, inspirée de l’univers rétro.</GridItem>
      <GridItem as="p">- Définir une charte graphique cohérente (logo, couleurs, typo)</GridItem>
      <GridItem as="p">- Réaliser un prototype mobile fluide centré sur les usages du public cible</GridItem>

      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [LIENS]
      </Box>
      <Box>
        <a href="https://www.figma.com/deck/CaqJYpNdfvuF0TDQjp51vR/Nature-morte?node-id=44-63&t=y6JjmR8hjL8YQH8W-1" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
          Slide deck Nature MORTE
        </a>
      </Box>
      <Box>
        <a
          href="https://www.figma.com/proto/GFY1G6BcP6GkE7tEKfgkIF/Nature-Mort?page-id=15%3A355&node-id=99-1946&viewport=-59%2C544%2C0.24&t=eGBtEewBC7r9GyZ6-1&scaling=scale-down&content-scaling=fixed"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          prototyte Mobile
        </a>
      </Box>
    </Box>
  );
};

export default NatureMorte;
